"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoWrapper = exports.HomeSearchWrapper = exports.SearchWrapper = exports.StyledRight = exports.StyledLeft = exports.Modules = exports.HeaderContent = exports.HeaderContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const constants_1 = require("../../constants");
exports.HeaderContainer = styled_components_1.default.header `
  ${({ isFixed }) => isFixed
    ? (0, styled_components_1.css) `
          position: fixed;
          z-index: 6;
          top: 0;
          right: 0;
          left: 0;
        `
    : (0, styled_components_1.css) `
          position: relative;
        `}

  display: block;
  min-height: ${constants_1.MOBILE_HEADER_HEIGHT}px;

  background-color: ${({ isTransparent, theme }) => (isTransparent ? 'transparent' : theme.colors.white.s100)};

  box-shadow: ${({ isTransparent, theme }) => (isTransparent ? 'none' : theme.shadow.z1)};

  transition: background-color ease 100ms;

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    min-height: ${constants_1.DEFAULT_HEADER_HEIGHT}px;
  }
`;
exports.HeaderContent = styled_components_1.default.div `
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
`;
exports.Modules = styled_components_1.default.div `
  position: relative;
  z-index: 9;

  display: -ms-grid;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 56px;
  align-items: center;
  box-sizing: content-box;
  width: 100%;
  max-width: 1900px;
  height: 56px;
  margin: 0 auto;

  -ms-grid-columns: 1fr 1fr 1fr;
  -ms-grid-rows: 56px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    grid-template-rows: 69px;
    height: 69px;

    -ms-grid-rows: 69px;

    transition: border-bottom-color 100ms ease;
  }
`;
exports.StyledLeft = styled_components_1.default.div `
  z-index: 2;

  display: flex;
  -ms-grid-column: 1;
  align-items: center;
  height: 100%;
  padding: 0 0 0 ${({ theme }) => theme.space.s200};
  margin-right: auto;
`;
exports.StyledRight = styled_components_1.default.div `
  z-index: 1;

  display: flex;
  -ms-grid-column: 3;
  justify-content: flex-end;
  align-items: center;
  padding: 0 ${({ theme }) => theme.space.s200} 0 0;

  column-gap: ${({ theme }) => theme.space.s200};
`;
exports.SearchWrapper = styled_components_1.default.div `
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
  align-items: center;
  width: 100%;
`;
exports.HomeSearchWrapper = (0, styled_components_1.default)(exports.SearchWrapper) `
  justify-content: center;

  height: ${({ isTransparent }) => (isTransparent ? '42px' : '0')};

  opacity: ${({ isTransparent }) => (isTransparent ? '1' : '0')};

  transition-duration: 0.2s;
  transition-property: height, opacity;

  transition-timing-function: linear;

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    height: ${({ isTransparent }) => (isTransparent ? '82px' : '0')};
  }
`;
exports.LogoWrapper = styled_components_1.default.div `
  display: flex;
  -ms-grid-column: 2;
  margin: auto;

  text-align: center;
`;
